import { render } from "./TemplateListView.vue?vue&type=template&id=083fbaa6&scoped=true"
import script from "./TemplateListView.vue?vue&type=script&lang=ts"
export * from "./TemplateListView.vue?vue&type=script&lang=ts"

import "./TemplateListView.vue?vue&type=style&index=0&id=083fbaa6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-083fbaa6"

export default script